import React from 'react';
import PropTypes from 'prop-types';
import { fieldPropTypes } from 'redux-form';
import { createNumberMask } from 'text-mask-addons';
import MaskedInput from 'react-text-mask';


import BaseInput from '../BaseInput';


const propTypes = {
  label: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  componentProps: PropTypes.object,
  ...fieldPropTypes,
};


const defaultProps = {
  label: null,
  componentProps: {},
};


const PercentInput = (props) => {
  const {
    componentProps,
    label,
    input,
    meta,
  } = props;

  const percentMask = createNumberMask({ suffix: ' %', prefix: '', integerLimit: 5, allowDecimal: true });

  return (
    <BaseInput
      label={label}
      input={input}
      meta={meta}
      componentClass={MaskedInput}
      componentProps={{
        guide: false,
        mask: percentMask,
        ...componentProps,
      }}
    />
  );
};


PercentInput.propTypes = propTypes;


PercentInput.defaultProps = defaultProps;


export default PercentInput;
